import { render } from "./TableA.vue?vue&type=template&id=8dc91306&scoped=true"
import script from "./TableA.vue?vue&type=script&lang=ts"
export * from "./TableA.vue?vue&type=script&lang=ts"

import "./TableA.vue?vue&type=style&index=0&id=8dc91306&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8dc91306"

export default script